import { render } from "./TreeTerminals.vue?vue&type=template&id=f0c5644e"
import script from "./TreeTerminals.vue?vue&type=script&lang=js"
export * from "./TreeTerminals.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__